/* global webkitSpeechRecognition */
/* eslint no-console: "off" */

let recognition;
let results = null;
let hasFinished = true;
let confidence;
let onEndCallback = null;
let onErrorCallback = null;

const SpeechRecognition = window.SpeechRecognition ||
  window.webkitSpeechRecognition ||
  window.mozSpeechRecognition ||
  window.msSpeechRecognition ||
  window.oSpeechRecognition;

const recognize = (function recognizeInit() {
  if (typeof SpeechRecognition === 'function') {
    recognition = new SpeechRecognition(); // eslint-disable-line new-cap
    recognition.continuous = true;
    recognition.interimResults = true;
  } else {
    recognition = {};
  }

  recognition.onstart = function onRecognitionStart() {
    console.log('speech recognition - onstart event.');
    hasFinished = false;
  };

  recognition.onresult = function onRecognitionResult(event) {
    console.log('speech recognition - onresult event.');
    let finalResults = '';
    let finalConfidence;
    let interimResults = '';


    for (let i = event.resultIndex; i < event.results.length; ++i) {
      if (event.results[i].isFinal) {
        finalResults += event.results[i][0].transcript;
        finalConfidence = event.results[i][0].confidence;
      } else {
        interimResults += event.results[i][0].transcript;
      }
    }
    results = finalResults || interimResults;
    confidence = finalConfidence;
  };


  recognition.onerror = function onRecognitionError(event) {
    console.error(event.error);
    console.error(event.message);
    hasFinished = true;

    if (typeof onEndCallback === 'function') {
      onErrorCallback(event.error);
    }
  };

  recognition.onend = function onRecognitionEnd() {
    console.log('speech recognition - onend event.');
    hasFinished = true;
    if (typeof onEndCallback === 'function') {
      onEndCallback();
    }
  };

  recognition.onaudiostart = () => { console.log('Speech recognition - audiostart event.'); };
  recognition.onaudioend = () => { console.log('Speech recognition - audioend event.'); };
  recognition.onnomatch = () => { console.log('Speech recognition - nomatch event.'); };
  recognition.onsoundstart = () => { console.log('Speech recognition - onsoundstart event.'); };
  recognition.onsoundend = () => { console.log('Speech recognition - onsoundend event.'); };
  recognition.onspeechstart = () => { console.log('Speech recognition - onspeechstart event.'); };
  recognition.onspeechend = () => { console.log('Speech recognition - onspeechend event.'); };

  function start(lang) {
    recognition.lang = lang;
    console.log(`recognise in ${lang}`);
    recognition.start();
  }

  function stop() {
    recognition.stop();
  }

  function getResults() {
    return {
      result: results,
      confidence: confidence || 0,
    };
  }

  function reset() {
    results = null;
    confidence = 0;
  }

  function setOnEndCallback(func) {
    if (typeof func === 'function') {
      onEndCallback = func;
    }
  }

  function setOnErrorCallback(func) {
    if (typeof func === 'function') {
      onErrorCallback = func;
    }
  }

  return {
    start,
    stop,
    reset,
    getResults,
    hasFinished,
    setOnEndCallback,
    setOnErrorCallback,
  };
}());

export default recognize;



// WEBPACK FOOTER //
// ./src/modules/speechrecognition.js